import dayjs from "dayjs";
import { t } from "i18next";

export const dateToUTC = (date: string | Date | null) => {
  return dayjs.utc(date);
};

export const utcToLocal = (date: Date | string): Date => {
  const newDate = new Date(date);
  return new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000);
};

export const localToUtc = (date: Date | string): Date => {
  const newDate = new Date(date);
  return new Date(newDate.getTime() - newDate.getTimezoneOffset() * 60000);
};

export const formatDate = (date: string | Date | null) => {
  if (date === null) {
    return null;
  }

  const parsedDate = dateToUTC(date);
  const hour = parsedDate.format("HH");
  const min = parsedDate.format("mm");

  if (parsedDate.isToday()) return `${t("common:today")} ${hour}:${min}`;

  if (parsedDate.isTomorrow()) return `${t("common:tomorrow")} ${hour}:${min}`;

  return parsedDate.format("DD.MM.YYYY HH:mm");
};

export const formatLocalDate = (date: string | Date | null | undefined) => {
  if (!date) return null;

  const parsedDate = dayjs(date);
  const hour = parsedDate.format("HH");
  const min = parsedDate.format("mm");

  if (parsedDate.isToday()) return `${t("common:today")} ${hour}:${min}`;

  if (parsedDate.isTomorrow()) return `${t("common:tomorrow")} ${hour}:${min}`;

  return parsedDate.format("DD.MM.YYYY HH:mm");
};
